import _ from 'lodash'
import React, { Component } from 'react'
import { connect } from 'react-redux'

import { listProjects } from '../actions/project'

import ProjectList from '../components/ProjectList'

class ProjectPage extends Component {
  componentDidMount () {
    const { listProjects } = this.props
    listProjects()
  }

  render () {
    return (<ProjectList {...this.props}/>)
  }
}

const mapStateToProps = (state, ownProps) => ({
  query: _.get(state, 'project.query'),
  order: _.get(state, 'project.query.order'),
  list: _.get(state, 'project.list'),
})

const mapDispatchToProps = (dispatch, ownProps) => ({
  listProjects (query = {}, order) {
    if (order) {
      let newOrder = `${order},DESC`
      if (query.order) {
        const orders = query.order.split(',')
        if (orders[0] === order) {
          newOrder = orders[1] === 'DESC' ? `${order},ASC` : `${order},DESC`
        }
      }
      query.order = newOrder
    }
    dispatch(listProjects(query))
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(ProjectPage)



// WEBPACK FOOTER //
// ./src/containers/ProjectPage.js